import { FunctionComponent, useEffect, useState } from 'react';
import Tile from '../Shared/Tiles/TileV2';
import './MyInsightsOneThirdTile.scss';
import { IBarChart, IBarChartData } from '../Models/BarChartModel';
import { IAgentQuoteData, IMyInsightsOneThirdTile } from '../Models/MyInsightsModel';
import { useAgentQuoteData } from '../../../Foundation/User/QuoteDataContext';
import HorizontalBarChart from '../Charts/HorizontalBarChart';
import RichText from '../Shared/Tiles/RichText';

const MyInsightsOneThirdTile: FunctionComponent<any> = (props: IMyInsightsOneThirdTile) => {
  const [barChartData, setBarChartData] = useState<IBarChart>();
  const { agentQuoteData } = useAgentQuoteData();

  useEffect(() => {
    const buildChartData = (quoteData: IAgentQuoteData | null) => {
      if (props && quoteData) {
        const chartData: IBarChartData[] = [];
        for (let i = 1; i <= 6; i++) {
          const itemLabel = props[`item${i}Label` as keyof IMyInsightsOneThirdTile] as string;
          const itemField = props[`item${i}Field` as keyof IMyInsightsOneThirdTile] as string;
          if (itemLabel) {
            const itemValue =
              quoteData && itemField in quoteData ? Number(quoteData[itemField as keyof IAgentQuoteData]) : 0;
            chartData.push({ name: itemLabel, value: itemValue });
          }
        }
        setBarChartData({ chartTitle: props.subtitle ?? '', barChartInput: chartData });
      }
    };
    buildChartData(agentQuoteData);
  }, [agentQuoteData, props]);

  return props ? (
    <Tile title={props.title ? props.title : 'My insights'} showStatCode={props.showAgencyCode}>
      <div className="myinsights-one-third-body">
        {barChartData && barChartData.barChartInput?.length > 0 && (
          <div className="myinsights-barchart-container">
            <HorizontalBarChart {...barChartData} />
          </div>
        )}
        {props.content && <RichText className="myinsights-rich-text-container" content={props.content} />}
      </div>
      {props.footer && <div className="myinsights-onethird-footer">{props.footer}</div>}
    </Tile>
  ) : (
    <></>
  );
};

export default MyInsightsOneThirdTile;
